import { createAsyncThunk } from '@reduxjs/toolkit';

import PAGE_CONTENT_API from './pageContent.api';

export const listPageContentAction = createAsyncThunk<
any,
PageContent.GetPageContentDetailPayload
>('pageContent.getList', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_CONTENT_API.listPageContentAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const detailPageContentAction = createAsyncThunk<any, { data: string }>(
  'pageContent.getDetail',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await PAGE_CONTENT_API.detailPageContentAPI(data);
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);

export const createPageContentAction = createAsyncThunk<
any,
PageContent.PageContentPostDetailPayload
>('pageContent.create', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_CONTENT_API.createPageContentAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const updatePageContentAction = createAsyncThunk<
any,
PageContent.PageContentPostDetailPayload
>('pageContent.update', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_CONTENT_API.updatePageContentAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const deletePageContentAction = createAsyncThunk<
any,
PageContent.DeletePageContentPayload
>('pageContent.delete', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_CONTENT_API.deletePageContentAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const listOrderContentAction = createAsyncThunk<
any,
PageContent.GetListOrdersPayload
>('pageContent.listOrder', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_CONTENT_API.listOrderContentAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const sortOrderContentAction = createAsyncThunk<
any,
PageContent.PostSortOrderPayload
>('pageContent.sortOrder', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_CONTENT_API.sortOrderContentAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});
